import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, ArrowLeft, Phone } from "lucide-react";
import { showcase, showcaseCategories, company } from "../mock";

const Showcase = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("All");
  const items = active === "All" ? showcase : showcase.filter((s) => s.category === active);

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-charcoal" style={{ backgroundColor: "#343434" }}>
        <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/")} className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-md bg-fire flex items-center justify-center"><Flame className="text-white" size={20} /></span>
            <span className="font-head font-bold uppercase text-white text-xl">Stove Scotland</span>
          </button>
          <div className="flex items-center gap-4">
            <a href={company.phoneHref} className="hidden sm:flex items-center gap-2 text-white font-semibold"><Phone size={17} className="text-fire" /> {company.phone}</a>
            <button onClick={() => navigate("/#quote")} className="btn-fire px-5 py-2.5 rounded-md font-semibold text-sm">Free Quote</button>
          </div>
        </div>
      </header>

      <section className="bg-grey py-14">
        <div className="max-w-7xl mx-auto px-5 text-center">
          <button onClick={() => navigate("/")} className="flex mx-auto items-center gap-2 text-gray-500 hover:text-fire transition-colors mb-5" data-testid="showcase-back-button"><ArrowLeft size={18} /> Back to home</button>
          <h1 className="text-charcoal font-medium text-[28px] md:text-[34px]">Our Stove Showcase</h1>
          <span className="block mx-auto w-24 h-[1.1px] bg-fire mt-2" />
          <p className="text-gray-600 mt-6 max-w-2xl mx-auto">A selection of multi-fuel and wood burning stoves we have supplied and installed across Scotland. Filter by installation type below.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-5">
          <div className="flex flex-wrap justify-center gap-3 mb-10">
            {showcaseCategories.map((c) => (
              <button key={c} onClick={() => setActive(c)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors ${active === c ? "bg-fire text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}>{c}</button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((s, i) => (
              <div key={i} className="group relative overflow-hidden rounded-xl shadow-md cursor-pointer">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={s.src} alt={s.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="inline-block bg-fire text-white text-xs font-medium px-2.5 py-1 rounded mb-2">{s.category}</span>
                  <p className="text-white font-head text-lg font-semibold uppercase">{s.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-charcoal py-14" style={{ backgroundColor: "#343434" }}>
        <div className="max-w-3xl mx-auto px-5 text-center">
          <h2 className="font-head text-3xl md:text-4xl font-bold uppercase text-white">Like What You See?</h2>
          <p className="text-white/70 mt-4">Get a free, no-obligation quote for your own stove installation today.</p>
          <button onClick={() => navigate("/#quote")} className="btn-fire mt-7 px-8 py-4 rounded-md font-semibold text-lg">Get My Free Quote</button>
        </div>
      </section>
    </div>
  );
};

export default Showcase;
